// @flow
import { has } from "../../utils/helpers/objects";

import AttributeModel from "./AttributeModel";

/**
 * Helptext attribute
 */
export default class HelptextAttributeModel extends AttributeModel {
  /**
   */
  static isApplicableModel(contributions: Object): boolean {
    return (
      contributions.type === "helptext" ||
      (contributions.readonly && has(contributions, "text"))
    );
  }

  /**
   */
  get type(): string {
    return "helptext";
  }

  /**
   * Get helptext text
   */
  get text(): string | null {
    const dataContent = this.getData("content");
    if (dataContent?.text) {
      return dataContent.text.message;
    }

    const contributionText = this.getContribution("text");
    if (contributionText) {
      return contributionText.message ?? contributionText;
    }

    return null;
  }

  /**
   */
  // eslint-disable-next-line no-unused-vars
  update(value: string): HelptextAttributeModel {
    return this;
  }

  /**
   */
  getFormData(): null {
    return null;
  }
}
